import type { RunFilters } from "@src/types/filters";

/**
 * Convert RunFilters to API query string
 *
 * Format: "field.OPERATOR:'value' AND field.OPERATOR:'value'"
 *
 * Example output:
 * - "end_ts.EQ:~" (active only - null check)
 * - "id.EQ:123"
 * - "job_id.EQ:456"
 * - "name.CON:'nexo'" (contains)
 */
export const convertRunFiltersToQuery = (filters: RunFilters): string | undefined => {
  const conditions: string[] = [];

  // Active filter (no end_ts = still running)
  if (filters.active) {
    conditions.push("end_ts.EQ:~");
  }

  // ID filter (exact match) - use != null to catch both null and undefined
  if (filters.id != null) {
    const idValue = Number(filters.id);
    if (Number.isFinite(idValue)) {
      conditions.push(`id.EQ:${idValue}`);
    } else {
      console.warn("Invalid id filter value:", filters.id);
    }
  }

  // Job ID filter (exact match) - use != null to catch both null and undefined
  if (filters.jobId != null) {
    const jobIdValue = Number(filters.jobId);
    if (Number.isFinite(jobIdValue)) {
      conditions.push(`job_id.EQ:${jobIdValue}`);
    } else {
      console.warn("Invalid jobId filter value:", filters.jobId);
    }
  }

  // Name filter (contains, case-insensitive)
  if (filters.name && typeof filters.name === "string") {
    const trimmed = filters.name.trim();
    if (trimmed) {
      const escaped = trimmed.replace(/'/g, "''");
      conditions.push(`name.CON:'${escaped}'`);
    }
  }

  // Return undefined if no conditions (cleaner than empty string)
  return conditions.length > 0 ? conditions.join(" AND ") : undefined;
};
